import React, { useState } from 'react';
import { Plugin, Action, Getter } from '@devexpress/dx-react-core';

export default function RowActionsState() {
    const [loadingRows, setLoadingRows] = useState([]);

    const handleLoading = ({ tableRowId, loading }) => {
        if (loading) {
            setLoadingRows([...loadingRows, tableRowId]);
        } else {
            setLoadingRows(loadingRows.filter(x => x !== tableRowId));
        }
    };

    const loadingRowsComputed = () => {
        return rowId => loadingRows.some(x => x === rowId);
    };

    return (
        <Plugin name="RowActionsState">
            <Getter name="loadingRows" computed={loadingRowsComputed} />
            <Action name="rowHandleLoading" action={handleLoading} />
        </Plugin>
    );
}



// WEBPACK FOOTER //
// ./data/components/pluginsTable/RowActionsState.js